import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { GET_FAVORITES } from '~/constants/endpoints';
import { FavoriteVehicle } from '~/contracts/common';

export default function fetchFavorites(
  zip5: string,
  controller?: AbortController
): AxiosPromise<FavoriteVehicle[]> {
  return httpWithAuth.get<FavoriteVehicle[]>(`${GET_FAVORITES}?zip5=${zip5}`, {
    signal: controller?.signal
  });
}
